import { createContext, useEffect, useMemo, useState } from 'react';
import { IChildrenProps } from '../Interfaces/IChildrenProps';
import { UserModel } from '../Models/UserModel';
import { PostUserByEmail } from '../API/LoginAPI';
import { useAuth } from 'oidc-react';


interface IUserModalProps {
    updateModal: () => void,
    userDb: UserModel,
}

export const UserDbContext = createContext({} as IUserModalProps);

const UserDbContextProvider = ({ children }: IChildrenProps) => {

    const [userDb, setUserDb] = useState<UserModel>({} as UserModel);

    const updateModal = () => setUserDb({} as UserModel);

    const auth = useAuth();
    let userData = auth?.userData;

    useEffect(() => {
        PostUserByEmail(userData?.profile.email ?? "", userData?.access_token ?? "").then((resp: any) => {
            setUserDb((v) => v = resp.data)
        });
    }, [])

    const value = useMemo(
        () => ({ userDb, updateModal }),
        [userDb]
    );

    return (
        <UserDbContext.Provider value={value}>
            {children}
        </UserDbContext.Provider>
    )
}
export default UserDbContextProvider;
